import React from 'react';
import { InputAdornment, Stack, TextField } from '@mui/material';

import { FilterSectionTitle } from 'components/candidate/CandidatesList/components/CandidateFilterSections';

export const ScoreFilterField: React.FC<{
  value: number | null;
  onChange: (value: number | null) => void;
}> = ({ value, onChange }) => (
  <Stack gap={1}>
    <FilterSectionTitle>TT score</FilterSectionTitle>
    <TextField
      type="number"
      size="small"
      value={value ?? ''}
      onChange={(event) =>
        onChange(event.target.value === '' ? null : Number(event.target.value))
      }
      inputProps={{ min: 0, max: 100, 'aria-label': 'TT score, % and above' }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">% and above</InputAdornment>
        ),
      }}
      sx={{ maxWidth: '14rem' }}
    />
  </Stack>
);
